import { Container, ErrorSection, ErrorCode, ErrorMessage, CTAButton, QuickLinksSection, QuickLink } from './styles'

export function NotFound() {
  const popularLinks = [
    { path: '/concreto', label: 'Calculadoras de Concreto' },
    { path: '/aco', label: 'Calculadoras de Aço' },
    { path: '/alvenaria', label: 'Calculadoras de Alvenaria' },
    { path: '/eletrica', label: 'Calculadoras Elétricas' },
    { path: '/hidrossanitario', label: 'Calculadoras Hidrossanitárias' },
    { path: '/geotecnia', label: 'Calculadoras de Geotecnia' },
  ]

  return (
    <Container>
      <ErrorSection>
        <div className="error-content">
          <ErrorCode>404</ErrorCode>
          <ErrorMessage>
            <h1>Página Não Encontrada</h1>
            <p className="subtitle">Ops! Parece que você se perdeu nos cálculos.</p>
            <p>A página que você está procurando não existe ou foi movida para outro endereço.</p>
          </ErrorMessage>
          <CTAButton to="/">Voltar para a Home</CTAButton>
        </div>
      </ErrorSection>

      <QuickLinksSection>
        <h2>Páginas Populares</h2>
        <p className="section-description">Que tal explorar uma dessas áreas?</p>
        <div className="quick-links-grid">
          {popularLinks.map((link, index) => (
            <QuickLink key={index} to={link.path}>
              {link.label}
            </QuickLink>
          ))}
        </div>
      </QuickLinksSection>
    </Container>
  )
}
